import React from "react";

import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import { Link } from "react-router-dom";

export default class ElementTree extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      structureSelected: [],
      structureExpanded: [],
    };
  }

  componentDidMount() {
    this.treeRestoreExpanded(this.props.elementId);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.shipId !== this.props.shipId ||
      prevProps.specId !== this.props.specId ||
      prevProps.elementId !== this.props.elementId
    ) {
      this.treeRestoreExpanded(this.props.elementId);
    }
  }

  treeGetPath = (id) => {
    let result = [];
    const items = this.props.items;
    if (id && Object.keys(items).length > 0) {
      if (items[`_${id}`]) {
        let parentNodeId = items[`_${id}`].parent;
        result = [String(id)];
        while (parentNodeId) {
          result.push(String(parentNodeId));
          parentNodeId = items[`_${parentNodeId}`].parent;
        }
      }
    }
    return result.reverse();
  };
  treeRestoreExpanded = (id) => {
    if (!id) {
      this.setState({ structureExpanded: [], structureSelected: [] });
    } else {
      const expanded = this.treeGetPath(id);
      this.setState({ structureExpanded: expanded, structureSelected: id });
    }
  };

  treeHandleToggle = (event, nodeIds) => {
    this.setState({ structureExpanded: nodeIds, structureSelected: [] });
  };
  treeHandleSelect = (event, nodeIds) => {
    this.setState({ structureSelected: nodeIds });
  };

  getChildren = (itemId) => {
    let children = [];
    for (let id in this.props.items) {
      let item = this.props.items[id];
      if (item.parent === itemId) children.push(item);
    }
    return children;
  };

  onClick = (e, item) => {
    if (this.props.onTreeClick) {
      e.preventDefault();
      this.props.onTreeClick(item);
    }
  };
  render() {
    const renderTree = (item) => (
      <TreeItem
        onClick={(e) => e.preventDefault()}
        key={item.id}
        nodeId={String(item.id)}
        label={
          <>
            <Link
              onClick={(e) => this.onClick(e, item)}
              className="d-block py-1 text-dark"
              to={`/element/${this.props.shipId}/${this.props.specId}/${item.id}`}
            >
              <div
                className={`row py-2 text-dark  align-items-center   ${
                  item.highlightItem === String(item.id) ? "bg-light" : ""
                }`}
              >
                <div className="col m-lg-0 my-3">
                  <div>
                    {item.critical && (
                      <i
                        title="Критическое оборудование"
                        className="fa fa-exclamation-triangle text-danger mr-2"
                      ></i>
                    )}
                    {item.label}
                  </div>
                  <div>
                    <span className="text-dark-50 small">{item.modelname}</span>
                    {item.count > 1 && (
                      <span className="text-dark-75 small ml-2">
                        {item.count} шт.
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </Link>
          </>
        }
        className="my-2"
        onLabelClick={(e) => e.preventDefault()}
      >
        {this.getChildren(item.id).map((item) => renderTree(item))}
      </TreeItem>
    );

    return (
      <>
        <TreeView
          defaultCollapseIcon={<i className="fa fa-angle-down"></i>}
          defaultExpandIcon={<i className="fa fa-angle-right"></i>}
          expanded={this.state.structureExpanded}
          selected={this.state.structureSelected}
          onNodeToggle={this.treeHandleToggle}
          onNodeSelect={this.treeHandleSelect}
        >
          {Object.entries(this.props.items).map(([id, item]) =>
            !item.parent ? renderTree(item) : null
          )}
        </TreeView>
      </>
    );
  }
}
